export function getIsWindowMaximized(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    try {
      window.wildtangent?.IsMaximized((isMax: boolean) => {
        resolve(isMax);
      });
    } catch (err) {
      reject(err);
    }
  });
}
